window.dzsapp_current_player_id_for_playlist = 0;
var dzsapFeedbacker = require('./js_common/_feedbacker');
// var dzsappRatings = require('./js_dzsapp/_starRatings');
var dzsappUploader = require('./js_dzsapp/_feUploader');

jQuery(document).ready(function ($) {


  var o = {
    settings_php_handler: ''
    , playerid: ''
  };


  if (window.dzsapp_settings) {

    o = $.extend(o, dzsapp_settings);
  }


  dzsapFeedbacker.feedbacker_init();
  // dzsappRatings.starRatings_init(o);
  dzsappUploader.uploader_init(o);


  if (window.dzsap_settings) {
    if (window.dzsap_settings.dzsaap_default_portal_upload_type && window.dzsap_settings.dzsaap_default_portal_upload_type !== 'audio') {
      setTimeout(function () {

        $('.bigoption-span[data-type="' + window.dzsap_settings.dzsaap_default_portal_upload_type + '"]').parent().trigger('click');
      }, 100);
    }
  }


  var selectors = '*[href="#dzsap-add-to-playlist"], .dzsapp-playlist-main-con .close-btn-con,.dzsapp-playlist-main-con .overlay-background, .add-playlist-trigger, .zoomsounds-portal--edit-track-btn';
  $(document).off('click.dzsap_document', selectors);
  $(document).on('click.dzsap_document', selectors, handle_mouse_document);
  $(document).on('change.dzsap_document', '.checkbox-playlist', handle_mouse_document);


  window.dzsapp_box_main_con = $('.dzsapp-playlist-main-con').eq(0);


  function handle_mouse_document(e) {


    var _t = $(this);

    if (e.type === 'change') {
      if (_t.hasClass('checkbox-playlist')) {
        console.info('_t.prop(\'checked\') - ', _t.prop('checked'));
        console.info('window.dzsapp_current_player_id_for_playlist - ', window.dzsapp_current_player_id_for_playlist);


        var insert_lab = 'on';


        if (_t.prop('checked') === false) {
          insert_lab = 'off'
        }


        var data = {
          dzsapp_action: 'insert_into_playlist'
          , playlist_id: _t.attr('name')
          , track_id: window.dzsapp_current_player_id_for_playlist
          , insert: insert_lab
        };


        $.ajax({
          type: "POST",
          url: o.settings_php_handler,
          data: data,
          success: function (response) {
            if (typeof window.console != "undefined") {
              console.log('Got this from the server: ' + response);
            }


            response = parse_response(response);
            show_notice(response);


            dzsapp_box_main_con.children('.overlay-background').trigger('click');

          },
          error: function (arg) {
            if (typeof window.console != "undefined") {
              console.log('Got this from the server: ' + arg, arg);
            }
            ;

          }
        });


      }
    }
    if (e.type === 'click') {


      // console.info("_t - ", _t.hasClass('overlay-background'));
      if (_t.hasClass('overlay-background') || _t.hasClass('close-btn-con')) {

        console.warn('window.dzsapp_box_main_con -6 ', window.dzsapp_box_main_con);

        window.dzsapp_box_main_con.find('.real-media').removeClass('triggered-create-playlist');
        window.dzsapp_box_main_con.removeClass('loading-item loaded-item');

        return false;

      }

      if (_t.hasClass('zoomsounds-portal--edit-track-btn')) {
        // console.log('123');

        // var _iframe2 = document.querySelector('.real-media > iframe');

        setTimeout(function () {

          var _iframe = $('.ultibox--real-media--iframe');
          if (_iframe[0] && _iframe[0].contentDocument) {
            console.log('_iframe[0].contentDocument - ', _iframe[0].contentDocument);
            var _icd = _iframe[0].contentDocument;

            _icd.querySelector('#publish').addEventListener('click', function () {
              // console.log("clicked");

              setTimeout(function () {

                window.close_ultibox();
              }, 500);
              setTimeout(function () {
                window.location.href = add_query_arg(window.location.href, 'reloaded-from-ultibox', 'on');
              }, 2000);
            })
          }
          // console.log('_iframe - ', _iframe, _iframe[0], document, $('.ultibox--real-media--iframe'));
        }, 3000);
      }
      if (_t.hasClass('add-playlist-trigger')) {
        var _con = _t.parent();

        _con.addClass('triggered-create-playlist');
      }

      if (_t.attr('href') == '#dzsap-add-to-playlist') {


        var _con = null;

        if (_t.parent().parent().hasClass('audioplayer')) {

          _con = _t.parent().parent();

          if (_con.attr('data-playerid')) {
            $('input[name="track_id_to_insert"]').val(_con.attr('data-playerid'));

            window.dzsapp_current_player_id_for_playlist = _con.attr('data-playerid');
          }

        }

        open_dzsap_lightbox({
          'call_from': 'click_open_embed_ultibox'
          , 'lightbox_open': 'playlist'
        })
        return false;
      }
    }
  }


  function open_dzsap_lightbox(pargs) {

    var margs = {
      'call_from': 'default'
      , 'lightbox_open': 'playlist'
    };


    if (pargs) {
      margs = $.extend(margs, pargs);
    }


    // console.info('ceva');

    var _c = window.dzsapp_box_main_con;
    var _t = $(this);

    // console.info('_c -> ',_c, cgallery.find('.feed-dzsap--for-social-networks').eq(0).html(), _c.find('.social-


    // console.info('window.dzsap_currplayer_from_share -> ', window.dzsap_currplayer_from_share);

    var aux = '';

    // -- aux is feed from social_feed


    if (window.dzsapp_box_main_con) {

      console.info('window.dzsapp_box_main_con - ', window.dzsapp_box_main_con);

      window.dzsapp_box_main_con.attr('style', '');


      window.dzsapp_box_main_con.find('.checkbox-add-to-playlist').each(function () {
        var _t3 = $(this);

        var post_arr_str = _t3.find('.post_arr_json').eq(0).html();
        var post_arr = [];

        try {
          post_arr = JSON.parse(post_arr_str);


          // console.info('post_arr - ',post_arr);


          var isIdFound = false;
          for (var lab in post_arr) {
            if (post_arr[lab] == window.dzsapp_current_player_id_for_playlist) {
              isIdFound = true;
            }
          }

          if (isIdFound) {

            _t3.find('input').prop('checked', true);
          } else {

            _t3.find('input').prop('checked', false);
          }

        } catch (err) {
          console.log(err);
        }
      })

      _c.addClass('loading-box-main-' + margs.lightbox_open);
      setTimeout(function () {

        _c.addClass('loading-item');


      }, 100);

      setTimeout(function () {
        _c.addClass('loaded-item');
      }, 200);


    } else {
      console.warn('missing box-main');
    }
  }


  function parse_response(response) {

    var arg = {};
    try {
      arg = JSON.parse(response);


    } catch (err) {
      console.log('did not parse', response);
    }

    return arg;
  }

  function show_notice(response) {


    if (typeof response == 'object') {
      if (response.report === 'success') {


        dzsapFeedbacker.feedbacker_show_message(response.text);
      }
      if (response.report === 'error') {

        dzsapFeedbacker.feedbacker_show_message(response.text, 'is-error');
      }
    } else {
      if (response.indexOf('error -') === 0) {
        dzsapFeedbacker.feedbacker_show_message(response.substr(7), 'is-error');
      }
      if (response.indexOf('success -') === 0) {
        dzsapFeedbacker.feedbacker_show_message(response.substr(9), 'is-error');
      }
    }


  }


  var cthis = null;


  $('.login-button').bind('click', function () {
    if ($('.login-form').hasClass('visible')) {
      $('.login-form').removeClass('visible')
    } else {
      $('.login-form').addClass('visible')
    }
  });


  var the_player_id = window.dzsap_settings.playerid;


  window.dzsapp_reinit = reinit_portal;

  reinit_portal();

  function reinit_portal() {

    $('.mainvp-con .extra-html').addClass('active');
    $('.shortcode-upload').addClass('loaded');
  }


  function setup_select_hidden() {

    for (let i = 0; i < jQuery('.select-hidden-metastyle').length; i++) {
      var _t = jQuery('.select-hidden-metastyle').eq(i);
      if (_t.hasClass('inited')) {
        continue;
      }
      //console.log(_t);
      _t.addClass('inited');
      _t.children('select').eq(0).bind('change', change_selecthidden);
      _t.find('.an-option').bind('click', click_anoption);
      change_selecthidden(null, _t.children('select').eq(0));
    }

    function change_selecthidden(e, arg) {
      var _c = jQuery(this);
      if (arg !== undefined) {
        _c = arg;
      }
      var _con = _c.parent();
      var selind = _c.children().index(_c.children(':selected'));
      var _slidercon = _con.parent()

//            console.info(_c, selind, _slidercon);

      _slidercon.find('.an-option').eq(selind).trigger('click');
      var selval = _con.children('select').eq(0).children().eq(selind).val();

//            console.info(_slidercon.find('.an-option').eq(selind))


      do_changemainsliderclass(_slidercon, selind, selval);
    }

    function click_anoption(e) {
      var _c = jQuery(this);
      var ind = _c.parent().children().index(_c);
      var _con = _c.parent().parent();
      var _slidercon = _con.parent();
      _c.parent().children().removeClass('active');
      _c.addClass('active');
      _con.children('select').eq(0).children().removeAttr('selected');
      _con.children('select').eq(0).children().eq(ind).attr('selected', 'selected');

      var selval = _con.children('select').eq(0).children().eq(ind).val();
//            console.log(_c, ind, _con, _slidercon);
      do_changemainsliderclass(_slidercon, ind, selval);
    }

    function do_changemainsliderclass(arg, argval, selval) {
      //extra function - handmade
      if (arg.hasClass('slider-con')) {
        arg.removeClass('mode_normal');
        arg.removeClass('mode_ytuser');
        arg.removeClass('mode_ytplaylist');
        arg.removeClass('mode_vimeouser mode_vimeochannel');
        if (argval == 0) {
          arg.addClass('mode_normal')
        }
        if (argval == 1) {
          arg.addClass('mode_ytuser')
        }
        if (argval == 2) {
          arg.addClass('mode_ytplaylist')
        }
        if (argval == 3) {
          arg.addClass('mode_vimeouser')
        }
        if (argval == 4) {
          arg.addClass('mode_vimeochannel')
        }

      } else {
        if (arg.hasClass('item-settings-con')) {
          arg.removeClass('mode_youtube mode_normal mode_vimeo mode_audio mode_image mode_link');

          if (argval == 0) {
            arg.addClass('mode_youtube')
          }
          if (argval == 1) {
            arg.addClass('mode_normal')
          }
          if (argval == 2) {
            arg.addClass('mode_vimeo')
          }
          if (argval == 3) {
            arg.addClass('mode_audio')
          }
          if (argval == 4) {
            arg.addClass('mode_image')
          }
          if (argval == 5) {
            arg.addClass('mode_link')
          }
        } else {
          if (arg.hasClass('dzsapp-page-upload--mainuploader')) {
//                        console.info(selval);

            arg.removeClass('type-video type-youtube type-vimeo type-soundcloud')
            arg.addClass('type-' + selval);
          } else {
            // console.info('warning - ',arg,' not slider-con, nor item-settings-con')
          }

        }

      }


    }

  }

  setup_select_hidden();



  $('.playlists-embed-btn').bind('click', function () {

    var _t = $(this);
    _t.parent().find('.dzsapp-code').fadeIn('fast');
    return false;
  })


//    console.info($('.playlists-con .playlist-btn'));


  //------ functions


  $(document).on('click', '.playlists-con .playlist-btn', click_playlist_btn);


  function click_playlist_btn() {
    var _t = $(this);

    console.info('click_playlist_btn', _t);
    if (_t.hasClass('active')) {


      if (the_player_id) {

      } else {
        if (window.dzsap_settings && dzsap_settings.playerid) {
          the_player_id = dzsap_settings.playerid;
        }
      }

      var data = {
        action: 'dzsapp_retract_playlist_entry',
        playlistname: _t.attr('data-playlistname'),
        playerid: the_player_id
      };


      $.ajax({
        type: "POST",
        url: o.settings_php_handler,
        data: data,
        success: function (response) {
          if (typeof window.console != "undefined") {
            console.log('Got this from the server: ' + response);
          }

          _t.removeClass('active');
        },
        error: function (arg) {
          if (typeof window.console != "undefined") {
            console.log('Got this from the server: ' + arg, arg);
          }
          ;

        }
      });


    } else {


      // -- plalist entry

      var data = {
        action: 'dzsapp_submit_playlist_entry',
        playlistname: _t.attr('data-playlistname'),
        playerid: the_player_id
      };


      $.ajax({
        type: "POST",
        url: o.settings_php_handler,
        data: data,
        success: function (response) {
          if (typeof window.console != "undefined") {
            console.log('Got this from the server: ' + response);
          }

          _t.addClass('active');
        },
        error: function (arg) {
          if (typeof window.console != "undefined") {
            console.log('Got this from the server: ' + arg, arg);
          }
          ;

        }
      });

    }
  }


  ;


})


function get_query_arg(purl, key) {
  if (purl.indexOf(key + '=') > -1) {
    //faconsole.log('testtt');
    var regexS = "[?&]" + key + "=.+";
    var regex = new RegExp(regexS);
    var regtest = regex.exec(purl);
    //console.info(regtest);

    if (regtest != null) {
      var splitterS = regtest[0];
      if (splitterS.indexOf('&') > -1) {
        var aux = splitterS.split('&');
        splitterS = aux[1];
      }
      //console.log(splitterS);
      var splitter = splitterS.split('=');
      //console.log(splitter[1]);
      //var tempNr = ;

      return splitter[1];

    }
    //$('.zoombox').eq
  }
}


jQuery(document).ready(function ($) {
  "use strict";
  var cthis = null;

  var the_player_id = 1;


  // console.info("HMM");
  $(document).on('click', '.btn-like', click_like);


  function click_like() {
    var _t = $(this);
    cthis = _t.parent().parent();

    the_player_id = $('.from-parse-songitem').eq(0).attr('data-postid');

    console.info('click_like from portal', cthis);

    if (cthis.hasClass('mainvp-con') == false) {
      console.info(cthis, ' not mainvp-con');
      return false;
    }
    // if(cthis.has(_t).length==0){  return; }

//        console.info(cthis, cthis.has(_t).length, _t.hasClass('active'));
    if (_t.hasClass('active')) {
      ajax_retract_like(_t);
    } else {
      ajax_submit_like(_t);
    }
  }


  function ajax_submit_like(argp) {
    //only handles ajax call + result
    var mainarg = argp;

    console.info(argp, data);

    if (!the_player_id) {
      // console.warn(window.dzsap_settings);
      if (window.dzsap_settings && dzsap_settings.playerid) {
        the_player_id = dzsap_settings.playerid;
      }
    }

    if (argp && argp.attr('data-playerid')) {
      the_player_id = argp.attr('data-playerid');
    }


    var data = {
      action: 'dzsap_submit_like',
      // postdata: mainarg,
      playerid: the_player_id
    };


    if (cthis.hasClass('mainvp-con') == false) {
      console.info(cthis, ' not mainvp-con');
      return false;
    } else {
    }
    ;


    var url = '';

    if (window.ajaxurl) {
      url = ajaxurl;
    } else {
      url = dzsapp_settings.site_url + 'index.php?dzsapp_action=dzsapp_submit_like';
    }

    $.ajax({
      type: "POST",
      url: url,
      data: data,
      success: function (response) {
        if (typeof window.console != "undefined") {
          console.log('Got this from the server: ' + response);
        }

        cthis.find('.btn-like').addClass('active');
        var auxlikes = cthis.find('.counter-likes .the-number').html();
        auxlikes = parseInt(auxlikes, 10);
        auxlikes++;
        cthis.find('.counter-likes .the-number').html(auxlikes);
      },
      error: function (arg) {
        if (typeof window.console != "undefined") {
          console.log('Got this from the server: ' + arg, arg);
        }
        ;


        cthis.find('.btn-like').addClass('active');
        var auxlikes = cthis.find('.counter-likes .the-number').html();
        auxlikes = parseInt(auxlikes, 10);
        auxlikes++;
        cthis.find('.counter-likes .the-number').html(auxlikes);
      }
    });
  }

  function ajax_retract_like(argp) {
    //only handles ajax call + result
    var mainarg = argp;
    if (argp && argp.attr('data-playerid')) {
      the_player_id = argp.attr('data-playerid');
    }
    var data = {
      action: 'dzsapp_retract_like',
      // postdata: mainarg,
      playerid: the_player_id
    };


    $.ajax({
      type: "POST",
      url: dzsapp_settings.site_url + 'index.php?dzsapp_action=dzsapp_retract_like',
      data: data,
      success: function (response) {
        if (typeof window.console != "undefined") {
          console.log('Got this from the server: ' + response);
        }

        cthis.find('.btn-like').removeClass('active');
        var auxlikes = cthis.find('.counter-likes .the-number').html();
        auxlikes = parseInt(auxlikes, 10);
        auxlikes--;
        cthis.find('.counter-likes .the-number').html(auxlikes);
      },
      error: function (arg) {
        if (typeof window.console != "undefined") {
          console.log('Got this from the server: ' + arg, arg);
        }
        ;

        cthis.find('.btn-like').removeClass('active');
        var auxlikes = cthis.find('.counter-likes .the-number').html();
        auxlikes = parseInt(auxlikes, 10);
        auxlikes--;
        cthis.find('.counter-likes .the-number').html(auxlikes);
      }
    });
  }


  $('.simple-fade-carousel').each(function () {
    var cthis = $(this);
    var currNr = 0;
    var time_interval = 5000;
    var int_changer = 0;

    cthis.children().eq(currNr).addClass('active');

    int_changer = setInterval(function () {
      currNr++;
      if (currNr >= cthis.children().length) {
        currNr = 0;
      }
      ;
      cthis.children().removeClass('active');
      cthis.children().eq(currNr).addClass('active');

    }, time_interval);

  })
});



